var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170:232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2471 17.1649C14.3404 17.4515 14.6608 17.6123 14.9616 17.5232L20.4142 15.9083C20.7147 15.8193 20.8833 15.5137 20.7899 15.2272L19.8476 12.3359C19.7717 12.103 19.5456 11.9531 19.3022 11.9531C19.2462 11.9531 19.1893 11.9611 19.1332 11.9777L13.6806 13.5926C13.535 13.6357 13.4158 13.7303 13.3448 13.8589C13.2737 13.9875 13.2596 14.1349 13.3048 14.2737L14.2471 17.1649Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0955 17L19.8012 17.339L21.0167 20.2529H15.9523L16.8178 18.1534L15.2567 18.4614L12.0351 26.2758C11.9163 26.564 12.1089 26.8755 12.4653 26.9716C12.5367 26.9909 12.6092 27 12.6805 27C12.9654 27 13.2307 26.8542 13.3258 26.6237L15.4986 21.353H21.4755L23.675 26.6256C23.7708 26.8552 24.0356 27 24.3195 27C24.3916 27 24.465 26.9906 24.537 26.971C24.893 26.8738 25.0842 26.5618 24.9641 26.274L21.0955 17Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3915 16.5837C22.4368 16.7225 22.536 16.8362 22.6709 16.9039C22.8058 16.9716 22.9606 16.9851 23.106 16.942L24.2157 16.6133H24.2156C24.3613 16.5702 24.4805 16.4756 24.5516 16.3469C24.6225 16.2183 24.6367 16.071 24.5915 15.9322L22.5603 9.69935C22.515 9.56062 22.4157 9.44686 22.2808 9.3792C22.1977 9.33756 22.1072 9.31641 22.0158 9.31641C21.9589 9.31641 21.9017 9.32462 21.8458 9.34117L20.7359 9.66979C20.4354 9.7588 20.2668 10.0644 20.3602 10.351L22.3915 16.5837Z",
    fill: "#00683A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2807 12.0153C26.0487 11.3032 25.5937 10.7084 24.9999 10.3402C24.6181 10.1036 24.2099 9.98198 23.8109 9.98047L25.4553 15.0264C26.3083 14.4634 26.6771 13.2317 26.2807 12.0153Z",
    fill: "#00683A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 17.4336C13.0713 17.3049 13.0855 17.1577 13.0402 17.0189L12.3974 15.0469C12.3215 14.8139 12.0954 14.6641 11.852 14.6641C11.796 14.6641 11.7392 14.672 11.683 14.6886L8.4018 15.6603C8.25621 15.7035 8.13693 15.7981 8.06589 15.9267C7.99492 16.0553 7.98073 16.2026 8.026 16.3414L8.66867 18.3134C8.71394 18.4523 8.81316 18.566 8.94807 18.6337C9.08299 18.7014 9.23768 18.7148 9.38307 18.6717C9.38307 18.6717 9.38307 18.6717 9.38314 18.6717L12.6643 17.7C12.81 17.6568 12.9293 17.5622 13.0003 17.4336Z",
    fill: "#00683A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170:232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18.0003,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesForecast);
export default __webpack_public_path__ + "static/media/sales-forecast.904202a0.svg";
export { ForwardRef as ReactComponent };